import { combineReducers } from '@reduxjs/toolkit';
import user from './userSlice';
import login from './loginSlice';
import register from './registerSlice';

const authReducers = combineReducers({
  user,
  login,
  register,
});

export default authReducers;
